module.exports = __webpack_public_path__ + "static/img/v004.6e68f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old_sites/v004.png
// module id = JTbg
// module chunks = 1